// extracted by mini-css-extract-plugin
export default {"investBlock":"InvestInfo_investBlock__6N0qB","profit":"InvestInfo_profit__0-t8M","total":"InvestInfo_total__s1ayW","profitTotal":"InvestInfo_profitTotal__gkUy8"};